import React from "react"
import styled from "@emotion/styled/macro"
import { theme, device } from "./Theme"


const ReviewsOuterContainer = styled.div`
box-sizing: border-box;
  max-width: 242px;
  display: grid;
  grid-template-columns: 78px 152px;
  grid-column-gap: 12px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  margin: 0.2rem 0;

  .ratingsContainer{
    background-color: ${theme.colors.primary};
  box-sizing: border-box;
  border-radius: 50%;
  color: ${theme.colors.light};
  font-size: clamp(1.2rem, -2.0192rem + 5.1923vw, 1.875rem);
  font-weight: 700;
display: grid;
align-items: center;
justify-content: center;
text-align: center;
padding: 15% 0;
.rating{
  width: 100%;
  max-width: 77px;
  line-height: 0;
}
  }
  .reviewsContainer{
box-sizing: border-box;
  }
  .reviewsNumber{
    font-size: clamp(1.2rem, -2.0192rem + 5.1923vw, 1.875rem);
  font-weight: 700;
  color: ${theme.colors.secondary};
  }
  .reviewsText{
    color: ${theme.colors.light};
    font-size: clamp(1rem, 0.4038rem + 0.9615vw, 1.125rem);
  }
`

const ReviewsWidgetCircleLeft = ( props, { instance }) => {


  function length(obj) {
    return Object.keys(obj).length
  }
  const totalRatings = length(props.data.reviewsForRatingValuePart1)
  const fiveFourThreeRatings = length(props.data.reviewsForRatingValuePart2)

  //console.log(totalRatings)
  //console.log(fiveFourThreeRatings)

  let total = 0
  const ratingsTotal = props.data.reviewsForRatingValuePart1
  let i
  for (i = 0; i < ratingsTotal.length; i++) {
    total += ratingsTotal[i].rating
  }
  //console.log(total);

  let averageRating = total / fiveFourThreeRatings
  averageRating = averageRating.toFixed(1)
  //console.log(averageRating)

  let rectWidth = averageRating * 20 + "%"
  //console.log(rectWidth)

  return (
    <ReviewsOuterContainer>
      <div className="ratingsContainer">
         <p>{averageRating}</p>
        
         <svg viewBox="0 0 1000 200" className="rating">
            <defs>
              <polygon
                id="star"
                points="100,0 131,66 200,76 150,128 162,200 100,166 38,200 50,128 0,76 69,66 "
              />

              <clipPath id={"stars" + instance}>
                <use xlinkHref="#star" />
                <use xlinkHref="#star" x="20%" />
                <use xlinkHref="#star" x="40%" />
                <use xlinkHref="#star" x="60%" />
                <use xlinkHref="#star" x="80%" />
              </clipPath>
            </defs>

            <rect
              style={{ fill: "#dddddd", height: "100%", width: "100%" }}
              clipPath={"url(#stars" + instance + ")"}
            ></rect>

            <rect
              width={rectWidth}
              style={{ fill: theme.colors.secondary, height: "100%" }}
              clipPath={"url(#stars" + instance + ")"}
            ></rect>
  </svg>
        </div>
        <div className="reviewsContainer">
        <p className="reviewsNumber">{totalRatings}</p>
        <p className="reviewsText">
          Customer Reviews
          </p>
  </div>
      
    </ReviewsOuterContainer>
  )
}
export { ReviewsWidgetCircleLeft }
